import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import { User } from 'services/action';
import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  data: null,
  isLoading: true,
  username: '',
  password: '',
  confirm_password: '',
};

export const FormUser = ({ uid, onSuccess, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const dummy = Array.from({ length: 7 }, (v, i) => i);

  const [
    {
      data,
      username,
      password,
      confirm_password,
      isLoading,
    },
    setState,
  ] = React.useState(initialState);

  const $handleSubmit = async (c) => {
    const payload = {
      type: data?.type,
      email: data?.email,
      name: data?.name,
      phone: data?.phone,
      username,
      password,
      confirm_password,
    };

    const submit = await Dispatch(User.$update(data?.id, payload));
    if (submit?.message === 'success') {
      onSuccess();
    }
  };

  const $onLoad = async(id) => {
    const res = await Dispatch(User.$show(id));
    if (res?.message === 'success') {
      setState((prevState) => ({...prevState, data: res?.data}));
    }
  }

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      username: data?.username,
    }));
  }, [data]);

  React.useEffect(() => {
    $onLoad(uid)
  }, [uid])

  if (isLoading) {
    return (
      <Modal.Body>
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      </Modal.Body>
    );
  }

  console.log('asu')

  return (
    <>
      <Modal.Body>
        <div className="form-group mb-3 text-start">
          <Form.Input
            value={username || ''}
            required
            disabled={data ? true : false}
            type="text"
            label="Username"
            autocomplete="off"
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                username: e?.target?.value,
              }))
            }
            error={StateForm?.errors?.username}
          />
          <Form.InputAddon
            value={password}
            required={!data}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                password: e?.target?.value,
              }))
            }
            label="Password"
            type="text"
            placeholder=""
            hint="password minimal 8 Karakter"
            error={StateForm?.errors?.password}
          />

          <Form.InputAddon
            value={confirm_password}
            required={!data}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                confirm_password: e?.target?.value,
              }))
            }
            label="Konfirmasi Password"
            type="text"
            placeholder=""
            autocomplete="off"
            error={StateForm?.errors?.confirm_password}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="row w-100">
          <div className="col">
            <Button
              type="button"
              className="btn btn-light w-100"
              onClick={() => onClose()}
            >
              Batal
            </Button>
          </div>
          <div className="col">
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '',
                'btn btn-primary w-100'
              )}
              disabled={StateForm?.loading}
              onClick={$handleSubmit}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
